<template>
  <el-dialog
    title="創建分類"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    class="dialogEdit"
  >
    <el-form :model="form">
      <el-form-item label="分類名稱" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off">
            <template slot="prepend">繁</template>
          </el-input>
          
          <el-input v-model="form.name_cn" autocomplete="off">
            <template slot="prepend">簡</template>
          </el-input>

          <el-input v-model="form.name_en" autocomplete="off">
            <template slot="prepend">英</template>
          </el-input>
      </el-form-item>
      <el-form-item label="圖標" prop="icon">
        <ipo3-upload @success="onSuccess" ref="upload"></ipo3-upload>
      </el-form-item>
      <!-- <el-form-item label="首頁專欄" :label-width="formLabelWidth">
        <el-switch v-model="form.ishome"></el-switch>
      </el-form-item> -->
      <el-form-item label="排序" :label-width="formLabelWidth">
        <el-input v-model="form.sort" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="是否顯示">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "compare_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        name: "",
        name_cn: "",
        name_en: "",
        icon: "",
        status: true,
        sort: 0,
        ishome:false,
      }
    };
  },
  methods: {
    show(value) {
      var self = this;
      this.dialogVisible = true;
      if (value !== undefined) {
        this.form = Object.assign({}, value);
        this.$refs.upload.setImage({
          url: self.form.icon,
          name: "news.jpg"
        });
        this.form.status = this.form.status == 1 ? true : false;
        this.form.ishome = this.form.ishome == 1 ? true : false;
      } else {
        this.form = { name: "", name_cn: "", name_en: "", icon: "", status: true, sort: 0 ,ishome:false};
        this.$refs.upload.setImage(null);
      }
    },
    onSuccess(image) {
      this.form.icon = image.path;
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      params.ishome = params.ishome?1:0;
      params.status = params.status?1:0;
      this.$http.post("/admin/category/edit", params).then(res => {
        if (res.code == 1) {
          self.$alert("分類已經存在！", '提示', {
            confirmButtonText: '確定',
            callback: action => {
              
            }
          });
          return;
        }
        self.$emit("sucess");
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit {
  text-align: left;
}
</style>